export const FD = {
  page: "form-designer-page",
  title: "form-designer-title",
  name: "form-designer-name",
  description: "form-designer-description",
  primaryTable: "form-designer-primary-table",
  savedForms: "form-designer-saved-forms",
  newFormBtn: "form-designer-new-form",
  deleteFormBtn: "form-designer-delete-form",
  openFormBtn: "form-designer-open-form",
  saveBtn: "form-designer-save",
  commandBar: "form-designer-command-bar",
  addControlBtn: "form-designer-add-control",
  deleteControlBtn: "form-designer-delete-control",
  confirmDialog: "form-designer-confirm-dialog",
  confirmDelete: "form-designer-confirm-delete",
  confirmCancel: "form-designer-confirm-cancel",

  workspace: "form-designer-workspace",
  palette: "form-designer-palette",
  paletteCollapse: "form-designer-palette-collapse",
  paletteExpand: "form-designer-palette-expand",
  paletteRail: "form-designer-palette-rail",
  propsCollapse: "form-designer-properties-collapse",
  propsExpand: "form-designer-properties-expand",
  propsRail: "form-designer-properties-rail",
  paletteFields: "form-designer-palette-fields",
  paletteFieldsEmpty: "form-designer-palette-fields-empty",
  paletteField: "form-designer-palette-field",
  paletteSearch: "form-designer-palette-search",
  paletteTable: "form-designer-palette-table",
  paletteTechnical: "form-designer-palette-technical",
  paletteTechnicalGroup: "form-designer-palette-technical-group",
  paletteFhirTab: "form-designer-palette-fhir-tab",
  paletteDbTab: "form-designer-palette-db-tab",
  paletteSemantic: "form-designer-palette-semantic",
  paletteSemanticField: "form-designer-semantic-field",
  paletteSemanticResource: "form-designer-semantic-resource",
  toolbox: "form-designer-toolbox",
  toolboxItems: "form-designer-toolbox-items",
  toolboxControl: "form-designer-toolbox-control",
  addCardEmptyBtn: "form-designer-add-card-empty",

  canvas: "form-designer-canvas",
  canvasGrid: "form-designer-canvas-grid",
  canvasEmpty: "form-designer-canvas-empty",
  addCardBtn: "form-designer-add-card",
  deleteCardBtn: "form-designer-delete-card",
  card: "form-designer-card",
  cardGrid: "form-designer-card-grid",
  cardTitle: "form-designer-card-title",
  cardClose: "form-designer-card-close",
  cardHandle: "form-designer-card-handle",
  cardResize: "form-designer-card-resize",
  cardPropCol: "form-designer-card-prop-col",
  cardPropRow: "form-designer-card-prop-row",
  cardPropWidth: "form-designer-card-prop-width",
  cardPropHeight: "form-designer-card-prop-height",
  alignLeft: "form-designer-align-left",
  alignRight: "form-designer-align-right",
  alignTop: "form-designer-align-top",
  alignBottom: "form-designer-align-bottom",
  control: "form-designer-control",
  controlResize: "form-designer-control-resize",

  props: "form-designer-properties",
  propsKind: "form-designer-properties-kind",
  cardPropTitle: "form-designer-card-prop-title",
  cardPropColumns: "form-designer-card-prop-columns",
  cardPropCollapsible: "form-designer-card-prop-collapsible",
  cardMoveUp: "form-designer-card-move-up",
  cardMoveDown: "form-designer-card-move-down",
  cardDelete: "form-designer-card-delete",
  controlPropName: "form-designer-control-prop-name",
  controlPropLabel: "form-designer-control-prop-label",
  controlPropField: "form-designer-control-prop-field",
  controlPropBindField: "form-designer-control-prop-bind-field",
  controlPropFhirPath: "form-designer-control-prop-fhir-path",
  controlPropFieldType: "form-designer-control-prop-field-type",
  controlPropSemanticField: "form-designer-control-prop-semantic-field",
  controlPropResourceType: "form-designer-control-prop-resource-type",
  controlPropType: "form-designer-control-prop-type",
  controlPropCol: "form-designer-control-prop-col",
  controlPropRow: "form-designer-control-prop-row",
  controlPropRequired: "form-designer-control-prop-required",
  controlPropReadOnly: "form-designer-control-prop-read-only",
  controlPropWidth: "form-designer-control-prop-width",
  controlPropHeight: "form-designer-control-prop-height",
  controlPropPlaceholder: "form-designer-control-prop-placeholder",
  controlPropHelpText: "form-designer-control-prop-help-text",
  controlPropCard: "form-designer-control-prop-card",
  controlDelete: "form-designer-control-delete",
};
